import { render } from "./CoverageDetails.vue?vue&type=template&id=c3709832"
import script from "./CoverageDetails.vue?vue&type=script&lang=js"
export * from "./CoverageDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__